module.exports = "https://cdn.hellotech.com/client-assets/thermostats_desktop_003ba19c79731f1ae95675a510454223.png";